module.exports = __webpack_public_path__ + "img/Icon-Arrow.e5d69f8f.svg";